import {Grid, GridItem} from "@consta/uikit/Grid";
import {Combobox} from "@consta/uikit/Combobox";
import {TextField} from "@consta/uikit/TextField";
import React, {useEffect, useState} from "react";
import {Attachment} from '@consta/uikit/Attachment';
import '../../css/pageBsi.css';
import {
    API_BSI_PAYLOAD,
    API_BSI_PROCESSING,
    API_BSI_SPLIT_PREVIEW,
    API_BSI_SPLIT_UPLOAD_JOBS,
    API_BSI_WELL_SEARCH,
    API_BSI_SIZE_CHECK,
    API_EQUIPAGE_LIST
} from "../../../service/api.endpoint";
import moment from "moment/moment";
import {IconTrash} from "@consta/uikit/IconTrash";
import {v4 as uuidv4} from 'uuid';
import cookieCmp from '../../../component/cookie.cmp';
import type {SnackBarItemStatus} from "@consta/uikit/SnackBar";
import * as S from "./modal.bsi.payload.styled";
import http from "../../../service/axiosConfig";
import {getPrimaryOrgName, getStoredUsername} from "../../../service/authAccess";
import ModalBsiDiagram from "./modal.bsi.diagram";


const username = getStoredUsername()
type SkkNameType = "CKK-Tehno" | "Nedrakam" | 'noname'


export type Item = {
    label: string;
    id: string;
};

export type ProcessingType = {
    data: string;
    equipage: string;
    fio: string;
    status: SnackBarItemStatus
};

type SplitTrip = {
    trip_index: number;
    label: string;
    descent_start: string;
    descent_end: string;
    descent_total: string;
    lift_start: string;
    lift_end: string;
    lift_total: string;
    depth: number;
    rows: number;
    well_id: string;
    bush: string;
    well: string;
    deposit: string;
    selected_well: WellOption | null;
    fio: string;
    diam: string;
};

type WellOption = {
    id: string;
    name: string;
    bush: string;
    deposit: string;
    label: string;
};

type OperationLogItem = {
    id: string;
    status: 'info' | 'success' | 'error' | 'warning';
    title: string;
    detail?: string;
};

type SplitUploadJobStatus = {
    id: string;
    status: 'PENDING' | 'RUNNING' | 'DONE' | 'ERROR';
    progress: number;
    processed: number;
    total: number;
    step: string;
    result?: any;
    error?: string;
};

const formatBsiFileTime = (value: string, format = 'HH:mm:ss') => {
    const parsed = moment.parseZone(value);
    if (!parsed.isValid()) {
        return '';
    }
    return parsed.utc().format(format);
};

interface ModalComponentProps {
    isOpen: boolean;
    onClose: any;
    nodeData: any
    files: any
}

// Получение CSRF токена из cookies
const csrftoken = cookieCmp('csrftoken');

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

function lastStringDate(contents: any) {
    for (let i = 1; i <= 5; i++) {
        try {
            const lst = moment(contents.split('\n').slice(-i)[0], 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm:ss');
            if (lst && lst !== 'Invalid date') {
                return lst
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const readFile = (file: any) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const contents = reader.result;
            resolve(contents);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsText(file);
    });
};

const ModalBsiPayload: React.FC<ModalComponentProps> = ({files, isOpen, onClose}) => {

    const [bsiFiles, setBsiFiles] = useState<File[]>([]);
    const [isSaving, setIsSaving] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [fileStatuses, setFileStatuses] = useState<Array<'pending' | 'processing' | 'success' | 'error'>>([]);

    const [itemsEquipage, setItemsEquipage] = useState<Item[]>([]);
    const [valueEquipage, setValueEquipage] = useState(Array(bsiFiles.length).fill(''));
    const [valueFIO, setValueFIO] = useState(Array(bsiFiles.length).fill(''));
    const [lastString, setLastString] = useState(Array(bsiFiles.length).fill(''));
    const [skkName, setSkkName] = useState(Array(bsiFiles.length).fill(''));
    const [bsiFileSize, setBsiFileSize] = useState(Array(bsiFiles.length).fill(''));
    const [bsiFileContent, setBsiFileContent] = useState<string[]>(Array(bsiFiles.length).fill(''));
    const [bsiDate, setBsiDate] = useState<string[]>(Array(bsiFiles.length).fill(''));
    const [splitTrips, setSplitTrips] = useState<Record<number, SplitTrip[]>>({});
    const [splitWellItems, setSplitWellItems] = useState<Record<string, WellOption[]>>({});
    const [isAnalyzingTrips, setIsAnalyzingTrips] = useState(false);
    const [diagramOpen, setDiagramOpen] = useState(false);
    const [diagramFileName, setDiagramFileName] = useState('');
    const [diagramFileContent, setDiagramFileContent] = useState('');
    const [diagramFileReading, setDiagramFileReading] = useState(false);
    const [operationLog, setOperationLog] = useState<OperationLogItem[]>([]);
    const [operationProgress, setOperationProgress] = useState(0);
    const [operationStep, setOperationStep] = useState('');
    const [bulkEquipage, setBulkEquipage] = useState<Item | null>(null);
    const [bulkFio, setBulkFio] = useState('');
    const [bulkDiam, setBulkDiam] = useState('50');

    useEffect(() => {
        if (!isOpen) {
            return;
        }
        document.body.classList.add('bsi-payload-modal-open');
        return () => {
            document.body.classList.remove('bsi-payload-modal-open');
        };
    }, [isOpen]);

    const resetAllState = () => {
        setBsiFiles([]);
        setValueEquipage([]);
        setValueFIO([]);
        setLastString([]);
        setSkkName([]);
        setBsiFileSize([]);
        setBsiFileContent([]);
        setBsiDate([]);
        setFileStatuses([]);
        setIsSaving(false);
        setUploadProgress(0);
        setCurrentFileIndex(0);
        setSplitTrips({});
        setSplitWellItems({});
        setIsAnalyzingTrips(false);
        setDiagramOpen(false);
        setDiagramFileName('');
        setDiagramFileContent('');
        setDiagramFileReading(false);
        setOperationLog([]);
        setOperationProgress(0);
        setOperationStep('');
        setBulkEquipage(null);
        setBulkFio('');
        setBulkDiam('50');
    };
    const handleDeleteFile = (index: number) => {
        const newBsiFiles = [...bsiFiles];
        newBsiFiles.splice(index, 1);
        setBsiFiles(newBsiFiles);

        const newValueEquipage = [...valueEquipage];
        newValueEquipage.splice(index, 1);
        setValueEquipage(newValueEquipage);

        const newValueFIO = [...valueFIO];
        newValueFIO.splice(index, 1);
        setValueFIO(newValueFIO);

        const newLastString = [...lastString];
        newLastString.splice(index, 1);
        setLastString(newLastString);

        const newSkkName = [...skkName];
        newSkkName.splice(index, 1);
        setSkkName(newSkkName);

        const newBsiFileSize = [...bsiFileSize];
        newBsiFileSize.splice(index, 1);
        setBsiFileSize(newBsiFileSize);

        const newBsiFileContent = [...bsiFileContent];
        newBsiFileContent.splice(index, 1);
        setBsiFileContent(newBsiFileContent);

        const newBsiDate = [...bsiDate];
        newBsiDate.splice(index, 1);
        setBsiDate(newBsiDate);

        const newFileStatuses = [...fileStatuses];
        newFileStatuses.splice(index, 1);
        setFileStatuses(newFileStatuses);

        setSplitTrips(prev => {
            const next: Record<number, SplitTrip[]> = {};
            Object.entries(prev).forEach(([key, value]) => {
                const numericKey = Number(key);
                if (numericKey < index) {
                    next[numericKey] = value;
                } else if (numericKey > index) {
                    next[numericKey - 1] = value;
                }
            });
            return next;
        });
        setSplitWellItems({});
    };

    const hasSplitMode = Object.values(splitTrips).some(items => items.length > 0);
    const allSplitTrips = Object.values(splitTrips).flat();
    const hasSplitTrips = allSplitTrips.length > 0;
    const allSplitTripsHaveWells = hasSplitTrips && allSplitTrips.every(trip => Boolean(trip.well_id));
    const allSplitTripsHaveFio = hasSplitTrips && allSplitTrips.every(trip => Boolean((trip.fio || '').trim()));
    const allFilesHaveEquipage = bsiFiles.length > 0 && bsiFiles.every((_, index) => Boolean(valueEquipage[index]?.id));
    const allFilesHaveFio = bsiFiles.length > 0 && bsiFiles.every((_, index) => Boolean((valueFIO[index] || '').trim()));
    const splitFileIndexes = Object.entries(splitTrips)
        .filter(([, trips]) => trips.length > 0)
        .map(([fileIndex]) => Number(fileIndex));
    const allSplitFilesHaveEquipage = splitFileIndexes.length > 0
        && splitFileIndexes.every(fileIndex => Boolean(valueEquipage[fileIndex]?.id));
    const hasLegacyValidationErrors = !hasSplitMode && bsiFileContent.some(item => Boolean(item));
    const hasProcessingFiles = fileStatuses.some(status => status === 'processing');
    const canAnalyzeTrips = bsiFiles.length > 0 && !isAnalyzingTrips && !isSaving && !hasProcessingFiles;
    const canSave = hasSplitMode
        ? allSplitTripsHaveWells && allSplitTripsHaveFio && allSplitFilesHaveEquipage
        : allFilesHaveEquipage && allFilesHaveFio && !hasLegacyValidationErrors;

    const addOperationLog = (item: Omit<OperationLogItem, 'id'>) => {
        setOperationLog(prev => [
            ...prev,
            {
                ...item,
                id: `${Date.now()}_${prev.length}`,
            }
        ]);
    };

    const updateUploadJobProgress = (job: SplitUploadJobStatus, fileIndex: number, filesCount: number) => {
        const fileProgress = Math.max(0, Math.min(100, Number(job.progress || 0)));
        const totalProgress = Math.round(((fileIndex + fileProgress / 100) / filesCount) * 100);
        setOperationProgress(Math.max(0, Math.min(99, totalProgress)));
        setOperationStep(job.step || `Сохраняем файл ${fileIndex + 1} из ${filesCount}`);
    };

    const waitForSplitUploadJob = async (jobId: string, fileIndex: number, filesCount: number) => {
        while (true) {
            await sleep(700);
            const response = await http.get(`${API_BSI_SPLIT_UPLOAD_JOBS}${jobId}/`, {
                headers: {
                    'X-CSRFToken': csrftoken,
                }
            });
            const job: SplitUploadJobStatus = response.data;
            updateUploadJobProgress(job, fileIndex, filesCount);
            if (job.status === 'DONE') {
                return job.result || {};
            }
            if (job.status === 'ERROR') {
                throw new Error(job.error || 'Ошибка фоновой загрузки БСИ');
            }
        }
    };

    const updateSplitTrip = (fileIndex: number, tripIndex: number, field: keyof SplitTrip, value: string) => {
        setSplitTrips(prev => ({
            ...prev,
            [fileIndex]: (prev[fileIndex] || []).map(trip =>
                trip.trip_index === tripIndex ? {...trip, [field]: value} : trip
            )
        }));
    };

    const getTripSearchKey = (fileIndex: number, tripIndex: number) => `${fileIndex}_${tripIndex}`;

    const applyBulkFields = (onlyEmpty: boolean) => {
        if (bulkEquipage) {
            setValueEquipage(prev => bsiFiles.map((_, index) => (
                onlyEmpty && prev[index]?.id ? prev[index] : bulkEquipage
            )));
        }
        if (bulkFio.trim()) {
            setValueFIO(prev => bsiFiles.map((_, index) => (
                onlyEmpty && (prev[index] || '').trim() ? prev[index] : bulkFio.trim()
            )));
        }
        if (bulkFio.trim() || bulkDiam.trim()) {
            setSplitTrips(prev => {
                const next: Record<number, SplitTrip[]> = {};
                Object.entries(prev).forEach(([fileIndex, trips]) => {
                    next[Number(fileIndex)] = trips.map(trip => ({
                        ...trip,
                        fio: bulkFio.trim() && (!onlyEmpty || !(trip.fio || '').trim())
                            ? bulkFio.trim()
                            : trip.fio,
                        diam: bulkDiam.trim() && (!onlyEmpty || !(trip.diam || '').trim())
                            ? bulkDiam.trim()
                            : trip.diam,
                    }));
                });
                return next;
            });
        }
        addOperationLog({
            status: 'info',
            title: onlyEmpty ? 'Заполнены пустые поля' : 'Поля применены ко всем файлам',
            detail: [
                bulkEquipage ? `Экипаж: ${bulkEquipage.label}` : '',
                bulkFio.trim() ? `ФИО: ${bulkFio.trim()}` : '',
                bulkDiam.trim() ? `Ø фрезы: ${bulkDiam.trim()}` : '',
            ].filter(Boolean).join('; ') || 'Нет заполненных массовых полей',
        });
    };

    const fetchSplitWells = async (fileIndex: number, tripIndex: number, search: string) => {
        if (!search.trim()) {
            setSplitWellItems(prev => ({...prev, [getTripSearchKey(fileIndex, tripIndex)]: []}));
            return;
        }
        try {
            const response = await http.get(API_BSI_WELL_SEARCH, {
                params: {
                    search,
                    equipage: valueEquipage[fileIndex]?.id || '',
                    org: getPrimaryOrgName() || '',
                    date: bsiDate[fileIndex] || '',
                }
            });
            setSplitWellItems(prev => ({
                ...prev,
                [getTripSearchKey(fileIndex, tripIndex)]: response.data || [],
            }));
        } catch (error) {
            setSplitWellItems(prev => ({...prev, [getTripSearchKey(fileIndex, tripIndex)]: []}));
        }
    };

    const handleSplitWellChange = (fileIndex: number, tripIndex: number, value: WellOption | null) => {
        setSplitTrips(prev => ({
            ...prev,
            [fileIndex]: (prev[fileIndex] || []).map(trip =>
                trip.trip_index === tripIndex
                    ? {
                        ...trip,
                        selected_well: value,
                        well_id: value?.id || '',
                        well: value?.name || '',
                        bush: value?.bush || '',
                        deposit: value?.deposit || '',
                    }
                    : trip
            )
        }));
    };

    const handleAnalyzeTrips = async () => {
        setIsAnalyzingTrips(true);
        setOperationLog([]);
        setOperationProgress(0);
        setOperationStep('Проверяем файлы и ищем проходки');

        for (let fileIndex = 0; fileIndex < bsiFiles.length; fileIndex += 1) {
            const file = bsiFiles[fileIndex];
            if (!file) {
                continue;
            }
            setFileStatuses(prev => {
                const newStatuses = [...prev];
                newStatuses[fileIndex] = 'processing';
                return newStatuses;
            });

            try {
                const formData = new FormData();
                formData.append('bsi_file', file, file.name);
                formData.append('skk_name', skkName[fileIndex] || 'CKK-Tehno');
                formData.append('file_modified_at', moment(file.lastModified).format('DD.MM.YYYY HH:mm:ss'));
                formData.append('last_row_date', lastString[fileIndex] || '');
                const response = await http.post(API_BSI_SPLIT_PREVIEW, formData, {
                    headers: {
                        'X-CSRFToken': csrftoken,
                        'Content-Type': 'multipart/form-data',
                    }
                });
                const trips: SplitTrip[] = (response.data?.trips || []).map((trip: any) => ({
                    ...trip,
                    well_id: '',
                    bush: '',
                    well: '',
                    deposit: '',
                    selected_well: null,
                    fio: valueFIO[fileIndex] || '',
                    diam: '50',
                }));
                setSplitTrips(prev => ({...prev, [fileIndex]: trips}));
                setBsiFileContent(prevContent => {
                    const updatedContent = [...prevContent];
                    updatedContent[fileIndex] = trips.length
                        ? ''
                        : response.data?.detail || `Проходки не найдены. Строк: ${response.data?.parsed_rows || 0}, max depth: ${response.data?.max_depth || 0} м`;
                    return updatedContent;
                });
                setFileStatuses(prev => {
                    const newStatuses = [...prev];
                    newStatuses[fileIndex] = trips.length ? 'success' : 'error';
                    return newStatuses;
                });
                addOperationLog({
                    status: trips.length ? 'success' : 'error',
                    title: `${file.name}: ${trips.length ? `найдено проходок ${trips.length}` : 'проходки не найдены'}`,
                    detail: trips.length
                        ? `Строк разобрано: ${response.data?.parsed_rows || 0}, максимальная глубина: ${response.data?.max_depth || 0} м`
                        : response.data?.detail || `Строк: ${response.data?.parsed_rows || 0}, max depth: ${response.data?.max_depth || 0} м`,
                });
            } catch (error) {
                setFileStatuses(prev => {
                    const newStatuses = [...prev];
                    newStatuses[fileIndex] = 'error';
                    return newStatuses;
                });
                setBsiFileContent(prevContent => {
                    const updatedContent = [...prevContent];
                    updatedContent[fileIndex] = getApiErrorMessage(error, 'Ошибка анализа проходок');
                    return updatedContent;
                });
                addOperationLog({
                    status: 'error',
                    title: `${file.name}: ошибка анализа`,
                    detail: getApiErrorMessage(error, 'Ошибка анализа проходок'),
                });
            }
            setOperationProgress(Math.round(((fileIndex + 1) / bsiFiles.length) * 100));
        }

        setIsAnalyzingTrips(false);
        setOperationStep('Проверка проходок завершена');
    };

    const handleSaveSplitTrips = async () => {
        const invalidFileIndexes = Object.entries(splitTrips)
            .filter(([, trips]) => trips.some(trip => !trip.well_id))
            .map(([fileIndex]) => Number(fileIndex));

        if (invalidFileIndexes.length > 0) {
            setBsiFileContent(prevContent => {
                const updatedContent = [...prevContent];
                invalidFileIndexes.forEach(index => {
                    updatedContent[index] = 'Для каждой проходки выберите скважину из списка';
                });
                return updatedContent;
            });
            addOperationLog({
                status: 'warning',
                title: 'Заполните скважины',
                detail: 'Для каждой найденной проходки нужно выбрать скважину из списка.',
            });
            return;
        }
        const emptyFioFileIndexes = Object.entries(splitTrips)
            .filter(([, trips]) => trips.some(trip => !(trip.fio || '').trim()))
            .map(([fileIndex]) => Number(fileIndex));

        if (emptyFioFileIndexes.length > 0) {
            setBsiFileContent(prevContent => {
                const updatedContent = [...prevContent];
                emptyFioFileIndexes.forEach(index => {
                    updatedContent[index] = 'Для каждой проходки укажите ФИО ответственного';
                });
                return updatedContent;
            });
            addOperationLog({
                status: 'warning',
                title: 'Заполните ФИО',
                detail: 'Для каждой найденной проходки нужно указать ФИО ответственного.',
            });
            return;
        }

        setIsSaving(true);
        setOperationLog([]);
        setOperationProgress(0);
        setOperationStep('Сохраняем проходки в график');
        const entries = Object.entries(splitTrips).filter(([, trips]) => trips.length > 0);

        for (let entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
            const [fileIndexString, trips] = entries[entryIndex];
            const fileIndex = Number(fileIndexString);
            if (!trips.length) {
                continue;
            }

            setFileStatuses(prev => {
                const newStatuses = [...prev];
                newStatuses[fileIndex] = 'processing';
                return newStatuses;
            });

            try {
                const orgName = getPrimaryOrgName();
                const formData = new FormData();
                formData.append('bsi_file', bsiFiles[fileIndex], bsiFiles[fileIndex].name);
                formData.append('date', bsiDate[fileIndex]);
                formData.append('equipage', valueEquipage[fileIndex].id);
                formData.append('org', orgName || '');
                formData.append('fio', valueFIO[fileIndex] || '');
                formData.append('skk_name', skkName[fileIndex] || 'CKK-Tehno');
                formData.append('file_modified_at', moment(bsiFiles[fileIndex].lastModified).format('DD.MM.YYYY HH:mm:ss'));
                formData.append('segments', JSON.stringify(trips.map(trip => ({
                    trip_index: trip.trip_index,
                    well_id: trip.well_id,
                    bush: trip.bush,
                    well: trip.well,
                    deposit: trip.deposit,
                    fio: trip.fio || valueFIO[fileIndex] || '',
                    diam: trip.diam || '50',
                }))));

                const jobResponse = await http.post(API_BSI_SPLIT_UPLOAD_JOBS, formData, {
                    headers: {
                        'X-CSRFToken': csrftoken,
                        'Content-Type': 'multipart/form-data',
                    }
                });
                const jobId = jobResponse.data?.id;
                if (!jobId) {
                    throw new Error('Сервер не вернул номер задачи загрузки');
                }
                setOperationStep(`Файл ${entryIndex + 1} из ${entries.length}: задача создана`);
                updateUploadJobProgress(jobResponse.data, entryIndex, entries.length);
                const jobResult = await waitForSplitUploadJob(jobId, entryIndex, entries.length);

                const createdItems = jobResult?.created || [];
                const skippedExisting = jobResult?.skipped_existing || [];
                const created = createdItems.length || 0;
                const skipped = skippedExisting.length || 0;
                const graphLinked = createdItems.filter((item: any) => item.graph).length;
                const notLinkedItems = createdItems.filter((item: any) => !item.graph);
                const isFullyLinked = created > 0 && graphLinked === created;
                const isOnlyExisting = created === 0 && skipped > 0;
                const errors = jobResult?.errors || [];
                const hasErrors = errors.length > 0;
                setFileStatuses(prev => {
                    const newStatuses = [...prev];
                    newStatuses[fileIndex] = (isFullyLinked || isOnlyExisting) && !hasErrors ? 'success' : 'error';
                    return newStatuses;
                });
                if ((!isFullyLinked && !isOnlyExisting) || hasErrors) {
                    setBsiFileContent(prevContent => {
                        const updatedContent = [...prevContent];
                        const reasons = [
                            notLinkedItems
                                .map((item: any) => `${item.well || 'скважина'}: ${item.match_reason || 'строка графика не найдена'}`)
                                .join('; '),
                            errors.map((item: any) => formatApiValue(item)).filter(Boolean).join('; '),
                        ].filter(Boolean).join('; ');
                        updatedContent[fileIndex] = `БСИ создано: ${created}, к графику привязано: ${graphLinked}. ${reasons}`;
                        return updatedContent;
                    });
                }
                addOperationLog({
                    status: (isFullyLinked || isOnlyExisting) && !hasErrors ? 'success' : 'warning',
                    title: `${bsiFiles[fileIndex]?.name || 'Файл'}: создано ${created}, привязано ${graphLinked}, уже было ${skipped}`,
                    detail: isFullyLinked && skipped === 0 && !hasErrors
                        ? createdItems.map((item: any) => `${item.well || 'скважина'} / ${item.bush || 'куст'} / ${item.depth || 0} м`).join('; ')
                        : [
                            createdItems.map((item: any) => `${item.well || 'скважина'}: загружено ${item.depth || 0} м`).join('; '),
                            skippedExisting.map((item: any) => `${item.well || 'скважина'}: уже есть БСИ ${item.depth || 0} м`).join('; '),
                            notLinkedItems.map((item: any) => `${item.well || 'скважина'}: ${item.match_reason || 'строка графика не найдена'}`).join('; '),
                            errors.map((item: any) => formatApiValue(item)).filter(Boolean).join('; '),
                        ].filter(Boolean).join('; '),
                });
            } catch (error) {
                const detail = getApiErrorMessage(error, 'Ошибка сохранения проходок');
                setFileStatuses(prev => {
                    const newStatuses = [...prev];
                    newStatuses[fileIndex] = 'error';
                    return newStatuses;
                });
                setBsiFileContent(prevContent => {
                    const updatedContent = [...prevContent];
                    updatedContent[fileIndex] = detail;
                    return updatedContent;
                });
                addOperationLog({
                    status: 'error',
                    title: `${bsiFiles[fileIndex]?.name || 'Файл'}: ошибка сохранения`,
                    detail,
                });
            }
            setOperationProgress(Math.round(((entryIndex + 1) / entries.length) * 100));
        }

        setIsSaving(false);
        setOperationStep('Сохранение завершено');
    };

    const handleSaveButton = async () => {
        if (hasSplitMode) {
            await handleSaveSplitTrips();
            return;
        }

        const hasErrors = bsiFileContent.some(msg => Boolean(msg));
        const missingFioIndexes = bsiFiles
            .map((_, index) => index)
            .filter(index => !(valueFIO[index] || '').trim());

        if (missingFioIndexes.length > 0) {
            setBsiFileContent(prevContent => {
                const updatedContent = [...prevContent];
                missingFioIndexes.forEach(index => {
                    updatedContent[index] = 'Укажите ФИО ответственного';
                });
                return updatedContent;
            });
            setOperationStep('Не заполнено ФИО');
            addOperationLog({
                status: 'warning',
                title: 'Заполните ФИО',
                detail: 'Для каждого файла БСИ нужно указать ФИО ответственного.',
            });
            return;
        }

        if (hasErrors) {
            setOperationStep('Есть ошибки перед загрузкой');
            addOperationLog({
                status: 'warning',
                title: 'Сохранение остановлено',
                detail: 'В одном или нескольких файлах есть ошибки. Проверьте причины в карточках файлов.',
            });
            return;
        }
        setIsSaving(true);
        setUploadProgress(0);
        setOperationLog([]);
        setOperationProgress(0);
        setOperationStep('Загружаем файлы БСИ');
        setFileStatuses(Array(bsiFiles.length).fill('pending'));

        try {
            // 1. Формируем массив с явной типизацией
            type FileWithDate = {
                file: File;
                dateString: string;
                index: number;
            };

            const mergedArraysBsi: FileWithDate[] = bsiFiles.map((file, index) => ({
                file,
                dateString: lastString[index] || "",
                index,
            }));

            // 2. Сортировка (без any)
            mergedArraysBsi.sort((a, b) => {
                const dateA = new Date(a.dateString);
                const dateB = new Date(b.dateString);
                return dateA.getTime() - dateB.getTime();
            });

            const totalFiles = mergedArraysBsi.length;
            let i = 0
            const processingGroups = new Map<string, {
                equipage: string;
                equipageLabel: string;
                date: string;
                fio: string;
                skk: SkkNameType;
                indexes: number[];
            }>();
            for (const {file, index: fileIndex} of mergedArraysBsi) {

                setCurrentFileIndex(fileIndex);
                setFileStatuses(prev => {
                    const newStatuses = [...prev];
                    newStatuses[fileIndex] = 'processing';
                    return newStatuses;
                });

                try {
                    const orgName = getPrimaryOrgName();
                    const formData = new FormData();
                    const uuid = uuidv4();
                    formData.append('id', uuid);
                    formData.append('bsi_file', file, `${uuid}.txt`);
                    formData.append('date', bsiDate[fileIndex]);
                    formData.append('equipage', valueEquipage[fileIndex].id);
                    orgName && formData.append('org', orgName);
                    formData.append('fio', valueFIO[fileIndex]);
                    formData.append('file_size', bsiFileSize[fileIndex]);
                    formData.append('last_string_date', lastString[fileIndex]);
                    formData.append('file_modified_at', moment(file.lastModified).format('DD.MM.YYYY HH:mm:ss'));
                    formData.append('skk_name', skkName[fileIndex]);
                    // @ts-ignore
                    formData.append('username', username);

                    const payloadResult = await http.post(API_BSI_PAYLOAD, formData, {
                        headers: {
                            'X-CSRFToken': csrftoken,
                            'Content-Type': 'multipart/form-data',
                        }
                    });

                    if (payloadResult.status === 201) {
                        addOperationLog({
                            status: 'info',
                            title: `${file.name}: файл загружен`,
                            detail: `Дата БСИ: ${bsiDate[fileIndex]}, экипаж: ${valueEquipage[fileIndex]?.label || ''}`,
                        });
                        const groupKey = [
                            valueEquipage[fileIndex].id,
                            orgName || "",
                            bsiDate[fileIndex],
                            skkName[fileIndex],
                        ].join("|");
                        const group = processingGroups.get(groupKey);
                        if (group) {
                            group.indexes.push(fileIndex);
                        } else {
                            processingGroups.set(groupKey, {
                                equipage: valueEquipage[fileIndex].id,
                                equipageLabel: valueEquipage[fileIndex].label,
                                date: bsiDate[fileIndex],
                                fio: valueFIO[fileIndex],
                                skk: skkName[fileIndex],
                                indexes: [fileIndex],
                            });
                        }
                    } else {
                        setFileStatuses(prev => {
                            const newStatuses = [...prev];
                            newStatuses[fileIndex] = 'error';
                            return newStatuses;
                        });
                        addOperationLog({
                            status: 'error',
                            title: `${file.name}: файл не загружен`,
                            detail: 'Сервер не вернул статус создания файла',
                        });
                    }
                    i = i + 1
                    setUploadProgress(Math.round((i / totalFiles) * 100));
                } catch (error) {
                    const detail = getApiErrorMessage(error, 'Ошибка загрузки файла БСИ');
                    setFileStatuses(prev => {
                        const newStatuses = [...prev];
                        newStatuses[fileIndex] = 'error';
                        return newStatuses;
                    });
                    setBsiFileContent(prevContent => {
                        const updatedContent = [...prevContent];
                        updatedContent[fileIndex] = detail;
                        return updatedContent;
                    });
                    addOperationLog({
                        status: 'error',
                        title: `${file.name}: ошибка загрузки файла`,
                        detail,
                    });
                    i = i + 1
                    setUploadProgress(Math.round((i / totalFiles) * 100));
                }
            }

            for (const group of Array.from(processingGroups.values())) {
                try {
                    const orgName = getPrimaryOrgName();
                    await http.post(API_BSI_PROCESSING, {
                        params: {
                            equipage: group.equipage,
                            org: orgName,
                            date: group.date,
                            skk_name: group.skk
                        }
                    }, {
                        headers: {
                            'X-CSRFToken': csrftoken
                        }
                    });
                    setFileStatuses(prev => {
                        const newStatuses = [...prev];
                        group.indexes.forEach((index: number) => {
                            newStatuses[index] = 'success';
                        });
                        return newStatuses;
                    });
                    addOperationLog({
                        status: 'success',
                        title: `${group.equipageLabel}: обработка завершена`,
                        detail: `Дата: ${group.date}, файлов в группе: ${group.indexes.length}`,
                    });
                } catch (error) {
                    const detail = getApiErrorMessage(error, 'Ошибка обработки БСИ');

                    setFileStatuses(prev => {
                        const newStatuses = [...prev];
                        group.indexes.forEach((index: number) => {
                            newStatuses[index] = 'error';
                        });
                        return newStatuses;
                    });
                    setBsiFileContent(prevContent => {
                        const updatedContent = [...prevContent];
                        group.indexes.forEach((index: number) => {
                            updatedContent[index] = detail;
                        });
                        return updatedContent;
                    });
                    addOperationLog({
                        status: 'error',
                        title: `${group.equipageLabel}: ошибка обработки`,
                        detail,
                    });
                }

            }

            setOperationProgress(100);
            setOperationStep('Загрузка завершена');
        } catch (error) {
            addOperationLog({
                status: 'error',
                title: 'Ошибка загрузки',
                detail: getApiErrorMessage(error, 'Не удалось завершить загрузку БСИ'),
            });
        } finally {
            setIsSaving(false);
        }
    };

    useEffect(() => {
        setBsiFiles(files)
    }, [files]);

    function bsiCheck(repeatData: any[]) {
        if (repeatData.length > 0) {
            return `Этот файл уже был загружен: найдены совпадения по дате и размеру файла (${repeatData.length}).`
        } else {
            return undefined
        }
    }

    const handleOpenDiagram = async (file: File) => {
        setDiagramOpen(true);
        setDiagramFileName(file.name);
        setDiagramFileContent('');
        setDiagramFileReading(true);
        try {
            const content = await readFile(file);
            setDiagramFileContent(String(content || ''));
        } catch (error) {
            setBsiFileContent(prevContent => {
                const updatedContent = [...prevContent];
                const fileIndex = bsiFiles.indexOf(file);
                if (fileIndex >= 0) {
                    updatedContent[fileIndex] = 'Не удалось прочитать файл для графика';
                }
                return updatedContent;
            });
        } finally {
            setDiagramFileReading(false);
        }
    };

    const handleCloseDiagram = () => {
        setDiagramOpen(false);
        setDiagramFileName('');
        setDiagramFileContent('');
        setDiagramFileReading(false);
    };

    function getApiErrorMessage(error: any, fallback: string) {
        const data = error?.response?.data;
        if (!data) {
            return error?.message || fallback;
        }
        if (typeof data === 'string') {
            return data;
        }
        if (data.detail) {
            return data.detail;
        }
        if (data.error) {
            return data.error;
        }
        const knownDetails = [
            formatApiValue(data.errors),
            formatApiValue(data.skipped_existing),
            formatApiValue(data.created),
        ].filter(Boolean).join('; ');
        if (knownDetails) {
            return knownDetails;
        }
        return formatApiValue(data) || fallback;
    }

    function formatApiValue(value: any): string {
        if (!value) {
            return '';
        }
        if (typeof value === 'string') {
            return value;
        }
        if (Array.isArray(value)) {
            return value.map(formatApiValue).filter(Boolean).join('; ');
        }
        if (typeof value === 'object') {
            if (value.detail) {
                return [
                    value.well ? `${value.well}` : '',
                    value.bush ? `куст ${value.bush}` : '',
                    value.depth ? `${value.depth} м` : '',
                    value.detail,
                ].filter(Boolean).join(' — ');
            }
            if (value.error) {
                return value.error;
            }
            return Object.entries(value)
                .filter(([, itemValue]) => (
                    typeof itemValue === 'string'
                    || typeof itemValue === 'number'
                    || typeof itemValue === 'boolean'
                ))
                .map(([key, itemValue]) => `${key}: ${itemValue}`)
                .join('; ');
        }
        return String(value);
    }

    useEffect(() => {
        bsiFiles.forEach((file: any, index) => {
                if (file) {
                    readFile(file)
                        .then(async (contents: any) => {
                                let SKK: SkkNameType = 'noname'
                                let dateElement: number = 6
                                let dataString;
                                try {
                                    const contentString = String(contents || '');
                                    const lines = contentString.split('\n');
                                    const isSKKNedrakam = (contents: string) => {
                                        const lines = contents.split('\n');
                                        const fourthLine = lines[4];
                                        const bsiCodes = ['670', '841', '591', '824', '655', '846', '444', '445', '843', '1057'];
                                        return bsiCodes.some(code => fourthLine.includes(code));
                                    };

                                    if (lines[0]?.includes("Tehno")) {
                                        SKK = "CKK-Tehno"
                                        dateElement = 3
                                    } else if (isSKKNedrakam(contentString)) {
                                        SKK = "Nedrakam"
                                        dateElement = 5
                                    }

                                    if (SKK === 'noname' && !contentString.includes('SK-SPO-2')) {
                                        throw new Error('Не удалось определить тип прибора по заголовку файла. Ожидался CKK-Tehno, Nedrakam или SK-SPO-2.');
                                    }
                                    if (file.size < 4000) {
                                        throw new Error(`Файл слишком маленький (${Math.round(file.size / 1000)} КБ). Обычно это пустой или неполный файл БСИ.`);
                                    }

                                    dataString = lines[dateElement];
                                    if (!dataString) {
                                        throw new Error(`Не найдена строка с датой БСИ: ожидали строку №${dateElement + 1} для типа ${SKK}.`);
                                    }
                                    const fileDate = moment(dataString.split(' ')[0], 'DD.MM.YYYY').format('YYYY-MM-DD');
                                    if (!fileDate || fileDate === 'Invalid date') {
                                        throw new Error(`Не удалось прочитать дату БСИ из строки: "${dataString}". Ожидался формат DD.MM.YYYY.`);
                                    }
                                    http.get(API_BSI_SIZE_CHECK, {params: {day: fileDate, file_size: file.size}})
                                        .then((response) => {
                                            const repeatData: [] = response.data;
                                            setBsiFileContent(prevContent => {
                                                const updatedContent: any = [...prevContent];
                                                updatedContent[index] = bsiCheck(repeatData);
                                                return updatedContent;
                                            });
                                        });

                                    setBsiDate(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = fileDate;
                                        return updatedContent;
                                    });
                                    setBsiFileSize(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = file.size
                                        return updatedContent;
                                    });
                                    setLastString(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = lastStringDate(contents)
                                        return updatedContent;
                                    });
                                    setSkkName(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = SKK
                                        return updatedContent;
                                    });

                                } catch (error: any) {
                                    setBsiFileContent(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = error?.message || 'Нет данных или файл БСИ поврежден: не удалось прочитать структуру файла.';
                                        return updatedContent;
                                    });
                                    dataString = ''
                                }
                            }
                        )
                        .catch((error) => {
                            console.error('Ошибка чтения файла:', error);
                        });
                }
            }
        )
    }, [bsiFiles]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await http.get(API_EQUIPAGE_LIST, {
                    params: {
                        is_for_upload: true
                    }
                });
                setItemsEquipage(response.data);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();

    }, [])

    return (
        <>
            <S.BsiPayloadModalGlobalShield/>
            <S.StyledModal
                className="modal_bsi"
                isOpen={isOpen}
                hasOverlay
                onEsc={() => {
                    if (!isSaving && !hasProcessingFiles) {
                        resetAllState();
                        onClose(false);
                    }
                }}
            >
                <S.ModalContainer>
                    <S.ModalHeader>
                        <S.ModalTitle>Загрузка файлов БСИ</S.ModalTitle>
                        <S.ModalSubtitle>
                            Выберите экипаж и укажите ФИО ответственного для каждого файла
                        </S.ModalSubtitle>
                    </S.ModalHeader>

                    <S.BulkPanel>
                        <S.BulkTitle>Массовое заполнение</S.BulkTitle>
                        <S.BulkFields>
                            <Combobox
                                size="s"
                                items={itemsEquipage}
                                value={bulkEquipage}
                                onChange={({value}) => setBulkEquipage(value as Item | null)}
                                placeholder="Экипаж"
                                disabled={hasProcessingFiles || isSaving || isAnalyzingTrips}
                            />
                            <TextField
                                size="s"
                                value={bulkFio}
                                onChange={({value}) => setBulkFio(value || '')}
                                placeholder="ФИО ответственного"
                                disabled={hasProcessingFiles || isSaving || isAnalyzingTrips}
                            />
                            <TextField
                                size="s"
                                value={bulkDiam}
                                onChange={({value}) => setBulkDiam(value || '')}
                                placeholder="Ø фрезы"
                                disabled={hasProcessingFiles || isSaving || isAnalyzingTrips}
                            />
                            <S.SmallActionButton
                                type="button"
                                onClick={() => applyBulkFields(false)}
                                disabled={hasProcessingFiles || isSaving || isAnalyzingTrips || (!bulkEquipage && !bulkFio.trim() && !bulkDiam.trim())}
                            >
                                Применить ко всем
                            </S.SmallActionButton>
                            <S.SmallActionButton
                                type="button"
                                onClick={() => applyBulkFields(true)}
                                disabled={hasProcessingFiles || isSaving || isAnalyzingTrips || (!bulkEquipage && !bulkFio.trim() && !bulkDiam.trim())}
                            >
                                Только к пустым
                            </S.SmallActionButton>
                        </S.BulkFields>
                    </S.BulkPanel>


                    <Grid cols="3" gap="xs">
                        {bsiFiles.map((file: File, index: number) => {
                            return (
                                <React.Fragment key={`key_${index}`}>
                                    <GridItem col={'3'} key={`grid_full_${index}`}>
                                        <S.FileCard>
                                            <Grid cols="3" gap="xs">
                                                <GridItem col={'1'} key={`grid1_${index}`}>
                                                    <Attachment
                                                        key={`attach_${index}`}
                                                        fileName={file.name}
                                                        fileExtension="txt"
                                                        fileDescription={`${Math.round(file.size / 1000)} КБ ${moment(file.lastModified).format('DD.MM.YYYY, HH:mm')}`}
                                                        errorText={bsiFileContent[index]}           // ← остаётся для ошибок валидации
                                                    />
                                                    {fileStatuses[index] && (
                                                        <S.FileActionsRow>
                                                            <S.FileStatus status={fileStatuses[index]}>
                                                                {fileStatuses[index] === 'pending' && '⏳ Ожидание'}
                                                                {fileStatuses[index] === 'processing' && '⚙️ Обработка...'}
                                                                {fileStatuses[index] === 'success' && (splitTrips[index]?.length ? '✓ Найдены проходки' : '✓ Успешно загружен')}
                                                                {fileStatuses[index] === 'error' && '✗ Ошибка'}
                                                            </S.FileStatus>
                                                            <S.SmallActionButton
                                                                type="button"
                                                                onClick={() => handleOpenDiagram(file)}
                                                                disabled={fileStatuses[index] === 'processing'}
                                                            >
                                                                Посмотреть график
                                                            </S.SmallActionButton>
                                                        </S.FileActionsRow>
                                                    )}
                                                    {fileStatuses[index] === 'processing' && (
                                                        <S.ProgressBarContainer>
                                                            <S.ProgressBarWrapper>
                                                                <S.ProgressBarFill progress={uploadProgress}/>
                                                            </S.ProgressBarWrapper>
                                                            <S.ProgressText>
                                                                <S.ProgressLabel>
                                                                    Обработка файлов...
                                                                </S.ProgressLabel>
                                                                <span>{uploadProgress}%</span>
                                                            </S.ProgressText>
                                                            <S.ProgressText style={{
                                                                fontSize: '12px',
                                                                color: '#718096',
                                                                marginTop: '4px'
                                                            }}>
                                                                <span>Файл {currentFileIndex + 1} из {bsiFiles.length}</span>
                                                            </S.ProgressText>
                                                        </S.ProgressBarContainer>
                                                    )}
                                                </GridItem>
                                                <GridItem col={'1'} key={`grid2_${index}`}>
                                                    <Combobox
                                                        key={`equipage_${index}`}
                                                        items={itemsEquipage}
                                                        value={valueEquipage[index]}
                                                        onChange={({value}) => {
                                                            const updatedValueEquipage = [...valueEquipage];
                                                            updatedValueEquipage[index] = value;
                                                            setValueEquipage(updatedValueEquipage);
                                                        }}
                                                        placeholder="Экипаж"
                                                        required={true}
                                                            disabled={fileStatuses[index] === 'processing' ||
                                                            fileStatuses[index] === 'pending'}
                                                    />
                                                </GridItem>
                                                <GridItem key={`grid3_${index}`}>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <TextField
                                                            key={`fio_${index}`}
                                                            id={`fioID_${index}`}
                                                            style={{width: '100%'}}
                                                            value={valueFIO[index]}
                                                            onChange={({value}) => {
                                                                const updatedValueFIO = [...valueFIO];
                                                                updatedValueFIO[index] = value;
                                                                setValueFIO(updatedValueFIO);
                                                            }}
                                                            type="text"
                                                            placeholder="Укажите ФИО"
                                                            autoComplete='on'
                                                            required={true}
                                                            disabled={fileStatuses[index] === 'processing' ||
                                                                fileStatuses[index] === 'pending'}
                                                        />
                                                        <IconTrash
                                                            key={`trash_${index}`}
                                                            className="iconTrash"
                                                            onClick={() => {
                                                                if (fileStatuses[index] !== 'processing') {
                                                                    handleDeleteFile(index);
                                                                }
                                                            }}
                                                            style={{
                                                                opacity: fileStatuses[index] === 'processing' ? 0.5 : 1,
                                                                cursor: fileStatuses[index] === 'processing' ? 'not-allowed' : 'pointer'
                                                            }}
                                                        />
                                                    </div>
                                                </GridItem>
                                            </Grid>
                                            {splitTrips[index]?.length > 0 && (
                                                <S.TripsPreview>
                                                    <S.TripsTitle>
                                                        Найдено проходок: {splitTrips[index].length}
                                                    </S.TripsTitle>
                                                    {splitTrips[index].map((trip) => (
                                                        <S.TripRow key={`${index}_${trip.trip_index}`}>
                                                            <S.TripMeta>
                                                                <strong>{trip.trip_index + 1}. {formatBsiFileTime(trip.descent_start)}</strong>
                                                                <span>
                                                                    {formatBsiFileTime(trip.descent_start, 'HH:mm')}–{formatBsiFileTime(trip.lift_end, 'HH:mm')}
                                                                    {' '}· {trip.depth} м · строк {trip.rows}
                                                                </span>
                                                            </S.TripMeta>
                                                            <Combobox
                                                                size="s"
                                                                items={splitWellItems[getTripSearchKey(index, trip.trip_index)] || []}
                                                                value={trip.selected_well}
                                                                placeholder="Скважина"
                                                                getItemLabel={(item: WellOption) => item.label}
                                                                getItemKey={(item: WellOption) => item.id}
                                                                onChange={({value}) => handleSplitWellChange(index, trip.trip_index, value as WellOption | null)}
                                                                onInputChange={({value}) => fetchSplitWells(index, trip.trip_index, value || '')}
                                                                disabled={fileStatuses[index] === 'processing'}
                                                            />
                                                            <TextField
                                                                size="s"
                                                                value={trip.fio}
                                                                placeholder="ФИО"
                                                                onChange={({value}) => updateSplitTrip(index, trip.trip_index, 'fio', value || '')}
                                                                disabled={fileStatuses[index] === 'processing'}
                                                            />
                                                            <TextField
                                                                size="s"
                                                                value={trip.diam}
                                                                placeholder="Ø фрезы"
                                                                onChange={({value}) => updateSplitTrip(index, trip.trip_index, 'diam', value || '')}
                                                                disabled={fileStatuses[index] === 'processing'}
                                                            />
                                                        </S.TripRow>
                                                    ))}
                                                </S.TripsPreview>
                                            )}
                                        </S.FileCard>
                                    </GridItem>
                                </React.Fragment>
                            );
                        })}
                    </Grid>

                    {(operationLog.length > 0 || isSaving || isAnalyzingTrips) && (
                        <S.OperationPanel>
                            <S.OperationHeader>
                                <div>
                                    <S.OperationTitle>Ход операции</S.OperationTitle>
                                    <S.OperationSubtitle>{operationStep || 'Ожидание действий'}</S.OperationSubtitle>
                                </div>
                                <S.OperationPercent>{operationProgress}%</S.OperationPercent>
                            </S.OperationHeader>
                            <S.OperationProgressTrack>
                                <S.OperationProgressFill progress={operationProgress}/>
                            </S.OperationProgressTrack>
                            <S.OperationLog>
                                {operationLog.length === 0 && (
                                    <S.OperationLogItem status="info">
                                        <strong>Операция запущена</strong>
                                        <span>Результаты появятся здесь после ответа сервера.</span>
                                    </S.OperationLogItem>
                                )}
                                {operationLog.map(item => (
                                    <S.OperationLogItem key={item.id} status={item.status}>
                                        <strong>{item.title}</strong>
                                        {item.detail && <span>{item.detail}</span>}
                                    </S.OperationLogItem>
                                ))}
                            </S.OperationLog>
                        </S.OperationPanel>
                    )}

                    <S.ButtonGroup>
                        <S.StyledButton
                            size="m"
                            view="ghost"
                            label="Найти проходки"
                            width="default"
                            onClick={handleAnalyzeTrips}
                            disabled={!canAnalyzeTrips}
                        />
                        <S.StyledButton
                            size="m"
                            view="primary"
                            label={hasSplitMode ? 'Сохранить проходки' : 'Сохранить'}
                            width="default"
                            onClick={() => {
                                handleSaveButton();
                            }}
                            disabled={isSaving || isAnalyzingTrips || hasProcessingFiles || !canSave}
                        />

                        <S.StyledButton
                            className='cancel'
                            size="m"
                            view="secondary"
                            label={operationProgress === 100 && !isSaving && !isAnalyzingTrips ? 'Закрыть' : 'Отменить'}
                            width="default"
                            onClick={() => {
                                resetAllState();
                                onClose(false);
                            }}
                            disabled={hasProcessingFiles}
                        />
                    </S.ButtonGroup>
                </S.ModalContainer>
            </S.StyledModal>
            {diagramOpen && (
                <ModalBsiDiagram
                    isOpen={diagramOpen}
                    onClose={handleCloseDiagram}
                    bsiFileDiagram={diagramFileContent}
                    localFileName={diagramFileName}
                    localFileReading={diagramFileReading}
                />
            )}
        </>
    )
};

export default ModalBsiPayload;
